import React from 'react';
import PropTypes from 'prop-types';
import Linkage from './Linkage';

function JoinLinkage({ label, to, separator, className }) {
  return (
    <>
      {separator}
      <Linkage label={label} to={to} linkClassName={className} />
    </>
  )
}

JoinLinkage.propTypes = {
  label: PropTypes.string,
  to: PropTypes.string,
  separator: PropTypes.string,
  className: PropTypes.string
}

export default JoinLinkage;
